<template>
    <div style="position: relative;">
        <!--<el-button class="btn-default" @click="onReset('formInline')">返回</el-button>-->
        <div class="hb">
			<button class="white_but but" @click="onReset()">返回</button>
            <button class="blue_but but" @click="exportPDF()" style="width: 70px;">导出PDF</button>
		</div>
        <!--overflow-y: auto;max-height: 560px;-->
        <div class="pdf_main" id="pdf_main">
            <p class="title bg">{{detailData.scorePolicyName}}</p>
            <div class="timeBox">
               <span>开始月份：</span>
                <i style="margin-right: 50px;">{{detailData.startMonth}}</i>
                <span>结束月份：</span>
                <i>{{detailData.endMonth}}</i>
                <i class="totalScore rg">{{detailData.totalScore}}</i>
				<span class="rg">满分：</span>
            </div>
            <table class="content">
                <thead>
                    <tr class="bg">
                        <th style="min-width: 36px;">序号</th>
						<th>评测内容</th>
						<th>评测指标</th>
						<th>打分规则</th>
						<th>评测分值</th>
						<th>备注</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for='(list,num) in detailItems'>
                        <tr class="bg">
                            <td colspan="2" style="padding: 0px;border-right: none;"><span class="titleBg">{{list.categoryName}}</span></td>
                            <td colspan="4"></td>
                        </tr>
                        <tr v-for='(val,num) in list.item'>
                            <td>{{num+1}}</td>
                            <td>{{val.categoryItemName}}</td>
                            <td>{{val.targetName}}</td>
                            <td>{{val.ruleName}}</td>
                            <td>{{val.score}}</td>
                            <td>
                                <template v-if="val.note!=undefined&&val.note!=''">
                                    {{val.note}}
                                </template>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="pdf_main" style="padding-bottom: 100px;" >
            <p class="title bg">{{detailData.scorePolicyName}}</p>
            <div class="timeBox">
                <span>开始月份：</span>
                <i style="margin-right: 50px;">{{detailData.startMonth}}</i>
                <span>结束月份：</span>
                <i>{{detailData.endMonth}}</i>
                <i class="totalScore rg">{{detailData.totalScore}}</i>
				<span class="rg">满分：</span>
            </div>
            <table class="content" style="margin-bottom: 100px;">
                <thead>
                    <tr class="bg">
                        <th style="width:30%">评测内容</th>
						<th>评测指标</th>
						<th>打分规则</th>
						<th>评测分值</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for='(list,num) in detailItems'>
                        <tr class="bg">
                            <td style="padding: 0px;border-right: none;"><span class="titleBg">{{list.categoryName}}</span></td>
                            <td colspan="3"></td>
                        </tr>
                        <tr v-for='(val,num) in list.item'>
                            <td>
                                <span style="position: relative;">{{val.categoryItemName}}
                                    <template v-if="val.note!=undefined&&val.note!=''">
                                        <el-tooltip placement="bottom-start">
                                            <div slot="content" class="explainTitle">{{val.note}}</div>
                                            <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
                                        </el-tooltip>
                                    </template>
                                </span>
                            </td>
                            <td>{{val.targetName}}</td>
                            <td>{{val.ruleName}}</td>
                            <td>{{val.score}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import {MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import JsPDF from 'jspdf'
export default {
  name: '',
  data () {
    return {
      detailData: {},
      detailItems: []
    }
  },
  created () {
    var that = this
    var param = {}
    param.id = that.$route.params.id
    api.post(config.khsHost + 'spv/policy/hhs/getScorePolicyDetail.do', param).then(function (response) {
      that.detailData = response.body
      var list = that.detailData.items
      var categoryId = ''
      var obj = {}
      list.forEach(function (i, index) {
        if (categoryId === '') {
          categoryId = i.categoryId
        }
        if (i.categoryId === categoryId) {
          if (JSON.stringify(obj) === '{}') {
            obj.categoryName = i.categoryName
            obj.item = []
          }
          obj.item.push(i)
          if (index !== (list.length - 1) && i.categoryId !== list[index + 1].categoryId) {
            that.detailItems.push(obj)
            categoryId = list[index + 1].categoryId
            obj = {}
          } else if (index === (list.length - 1)) {
            that.detailItems.push(obj)
          }
        }
      })
    })
  },
  methods: {
    onReset () {
      this.$router.push({path: '/supervisor'})
    },
    exportPDF () {
      var self = this
      let downPdf = document.getElementById('pdf_main')
      window.html2canvas(downPdf, {
        width: downPdf.scrollWidth,
        height: downPdf.scrollHeight,
        onrendered: function (canvas) {
          canvas.fillStyle = '#fff'
          var contentWidth = canvas.width
          var contentHeight = canvas.height
        //   一页pdf显示html页面生成的canvas高度
          var pageHeight = contentWidth / 592.28 * 841.89
        //   未生成pdf的html页面高度
          var leftHeight = contentHeight
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28
          var imgHeight = 592.28 / contentWidth * contentHeight
          var position = 841.89 % (imgHeight / downPdf.scrollHeight * 50)
          var pageData = canvas.toDataURL('image/jpeg', 1.0)
          var pdf = new JsPDF('', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
            // 避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage()
              }
            }
          }
          pdf.save(self.detailData.scorePolicyName + '.pdf')
        },
        background: '#FFF'
      })
    }
  }
//   watch: {
//     $route: {
//       handler: function (val, oldVal) {
//         var that = this
//         var param = {}
//         api.post(config.khsHost + 'spv/policy/hhs/getScoreDetail.do', param).then(function (response) {
//           that.detailData = response.body
//         })
//       },
//       deep: true
//     }
//   }
}
</script>

<style scoped>
.pdf_main{
    position: absolute;
    width: 100%;
    background: #fff;
}
.hb {
    margin: 10px 0;
}
.but {
    height: 35px;
    width: 60px;
    border-radius: 6px;
    margin-left: 10px;
    border: none;
    cursor: pointer;
}
.white_but {
    color: #333;
    background: #fff;
    border: 1px solid #d9d9d9;
}
.blue_but {
    color: #FFF;
    background: #63a0f0;
    border: none;
}
.prompt_text {
    width: 100%;
    display: inline-block;
    line-height: 20px;
}

.title {
    text-align: center;
    font-size: 18px;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    margin: 0;
}

.bg {
    background: #f4f5fa;
}

.titleBg{
    display: inline-block;
    background: #fff;
    width: 100%;
    height: 41px;
    margin-top: 8px;
    border-top-right-radius: 49px;
    line-height: 45px;
    padding-left: 15px;
    font-size: 16px;
    box-sizing: border-box;
}

.timeBox {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    background: #fff;
}

.timeBox i {
    font-style: normal;
}

.content {
    background: #fff;
    width: 100%;
    border-collapse: separate;
}

.content th{
    border-top: 1px solid #ddd;
}

.content tr {
    height: 50px;
    box-sizing: border-box;
}

.content th,
.content td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    padding-left: 15px;
    text-align: left;
}

.ftui-msg-content {
    background: #fff;
}
.rg{
    float: right;
}
.explainTitle {
    width: 180px;
}
</style>


// WEBPACK FOOTER //
// src/components/supervisor/supervisorDetail.vue